import { OpenAttachmentsPopupItem } from "@/Common/Models/Attachments/OpenAttachmentsPopupItem";

interface IOpenAttachmentsPopup {
    onCloseCallback: () => void;

    Attachments: OpenAttachmentsPopupItem[];
    Xposition: number;
    Yposition: number;
}

class OpenAttachmentsPopup extends React.Component<IOpenAttachmentsPopup, never> {
    public render(): JSX.Element {
        var self = this;
        var style: React.CSSProperties = { position: "absolute", left: this.props.Xposition.toString() + "px", top: this.props.Yposition.toString() + "px" };

        return (
            <div id="muli_file_wd" style={style} onClick={(e: React.MouseEvent) => { e.stopPropagation(); }} className="attachments-popup" aria-hidden="false" aria-autoclose="false">
                <div className="notes-dropdown-content">
                    <h3>{cacheStore.GetString("AttachmentsLabel")}</h3>
                    <div>
                        {this.props.Attachments != null && self.props.Attachments.map((att, idx) => {
                            var self = this;
                            return (
                                <div key={idx + "__AttachmentsPopup"}>
                                    <a onClick={() => { att.openFileCallback(); self.props.onCloseCallback(); }} target="_blank">{att.fileTitle}</a>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export { OpenAttachmentsPopup };
